import { Link } from "react-router-dom";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";
import { cn } from "@/lib/utils";

const BuyerAuthFooter = () => {
  const { isAndroid } = useSafeAreaInsets();

  return (
    <footer className={cn(
      "border-t border-gray-800 py-8 px-4",
      isAndroid ? "pb-8" : "pb-[calc(2rem+env(safe-area-inset-bottom))]"
    )}>
      <div className="container mx-auto text-center text-gray-400">
        <p className="mb-4">&copy; {new Date().getFullYear()} GoDyspo. All rights reserved.</p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
          <Link 
            to="/consumer" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Consumer Products
          </Link>
          <Link 
            to="/buyer/faq" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            FAQ
          </Link>
          <Link 
            to="/contact" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Contact Us
          </Link>
          <Link 
            to="/privacy-policy" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Privacy Policy
          </Link>
          <Link 
            to="/terms-and-conditions" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Terms & Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default BuyerAuthFooter;
